import Index from '@/components/report/Index.vue'
import Environment from '@/components/report/Environment.vue'
import Inputs from '@/components/report/Inputs.vue'
import Labor from '@/components/report/Labor.vue'
import Harvest from '@/components/report/Harvest.vue'

export default {
  path: 'report',
  component: Index,
  redirect: to => {
    return `${to.path}/environment`
  },
  children: [
    /**
     * 环境报表
     */
    {
      path: 'environment',
      component: Environment
    },
    /**
     * 投入报表
     */
    {
      path: 'inputs',
      component: Inputs
    },
    /**
     * 用工报表
     */
    {
      path: 'labor',
      component: Labor
    },
    /**
     * 采摘报表
     */
    {
      path: 'harvest',
      component: Harvest
    },
  ]
}



// WEBPACK FOOTER //
// ./src/router/report.js